import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import {
  getStatusColor,
  getStatusColorForDeficiency,
  getStatusColorForInspection,
} from '../../utilities/utilityFunctions';
interface Props {
  taskStatusId?: number;
  inspectionStatusId?: number;
  workPackageId?: number;
}

const useStyles = makeStyles(() =>
  createStyles({
    statusLabelGrid: {
      '& .statusStyleOnGoing': {
        paddingRight: 44,
        fontWeight: '600',
        marginLeft: 'auto',
        width: 'fit-content',
        color: (props: Props) => getStatusColor(props.taskStatusId as number),
      },
      '& .reAssignButtonRemovalOnGoing': {
        paddingRight: 64,
        fontWeight: '600',
        color: (props: Props) => getStatusColor(props.taskStatusId as number),
      },
      '& .statusStyleApproval': {
        paddingRight: 44,
        fontWeight: '600',
        marginLeft: 'auto',
        width: 'fit-content',
        color: (props: Props) => getStatusColor(props.taskStatusId as number),
      },
      '& .reAssignButtonRemovalApproval': {
        paddingRight: 74,
        fontWeight: '600',
        color: (props: Props) => getStatusColor(props.taskStatusId as number),
      },
      '& .singleStatusStyleOnGoing': {
        paddingRight: 64,
        fontWeight: '600',
        marginLeft: 'auto',
        width: 'fit-content',
        color: (props: Props) => getStatusColorForInspection(props.inspectionStatusId as number),
      },
      '& .singleStatusStyleApproval': {
        paddingRight: 74,
        fontWeight: '600',
        color: (props: Props) => getStatusColorForInspection(props.inspectionStatusId as number),
      },
      '& .deficiencyStatus': {
        paddingRight: 64,
        fontWeight: '600',
        color: (props: Props) =>
          getStatusColorForDeficiency(props.taskStatusId as number, props.workPackageId as number),
      },
    },
  }),
);

export default useStyles;
